// import React from "react";
// import { useLocation, Routes, Route, Navigate } from "react-router-dom";
// import { Container } from "reactstrap";
// import { useAuth } from "../auth/AuthContext";
// import Navbar from "components/Navbars/Navbar";
// import AdminFooter from "components/Footers/AdminFooter";
// import Sidebar from "components/Sidebar/Sidebar";
// import MobileSidebarNav from "components/Sidebar/MobileSidebarNav";
// import { useRoutes } from "routes";

// import { api } from "../config/middleware"; // ปรับ path ให้ตรงโปรเจค
// import { API_GETSETTING } from "../config/api"; // ปรับ path ให้ตรง
// import { useSettingStore } from "../stores/settingStore"; // ปรับ path ให้ตรง

// // helper
// const flattenRoutes = (rs, { includeHidden = false } = {}) =>
//   (Array.isArray(rs) ? rs : [])
//     .flatMap((r) =>
//       r?.children
//         ? r.children.filter((c) => includeHidden || !c.hidden)
//         : includeHidden || !r?.hidden
//         ? [r]
//         : []
//     )
//     .filter((r) => r?.path);

// const useCurrentRole = () => {
//   const { user } = useAuth();
//   return (user?.role || localStorage.getItem("role") || "user").toLowerCase();
// };

// const User = () => {
//   const routes = useRoutes();
//   const mainContent = React.useRef(null);
//   const location = useLocation();
//   const role = useCurrentRole();

//   const { user } = useAuth();
//   const tnId = user?.tnId;
//   const orgId = user?.orgId;
//   const brId = user?.brId;

//   const setBillMode = useSettingStore((s) => s.setBillMode);
//   const [settingReady, setSettingReady] = React.useState(false);

//   React.useEffect(() => {
//     document.documentElement.scrollTop = 0;
//     document.scrollingElement.scrollTop = 0;
//     if (mainContent.current) mainContent.current.scrollTop = 0;
//   }, [location]);

//   // ✅ fetch setting เมื่อ login คนใหม่ / org/branch เปลี่ยน
//   React.useEffect(() => {
//     let alive = true;

//     const run = async () => {
//       // ยังไม่มีข้อมูล user ก็อย่าเพิ่งโหลดเมนู
//       if (tnId == null || orgId == null || brId == null) {
//         setSettingReady(false);
//         return;
//       }

//       try {
//         setSettingReady(false);

//         const res = await api.get(API_GETSETTING, {
//           params: { TNID: tnId, ORGID: orgId, BRID: brId },
//         });

//         if (!alive) return;

//         if (res.data?.statustext === "SUCCESS") {
//           const s = res.data?.data || {};
//           // billMode จาก API เป็น 0/1
//           setBillMode(Number(s.billMode ?? 1));
//         } else {
//           // fallback
//           setBillMode(1);
//         }
//       } catch (e) {
//         if (!alive) return;
//         setBillMode(1);
//       } finally {
//         if (alive) setSettingReady(true);
//       }
//     };

//     run();
//     return () => {
//       alive = false;
//     };
//   }, [tnId, orgId, brId, setBillMode]);

//   // routes สำหรับลงทะเบียน (รวม hidden)
//   const allRoutes = React.useMemo(
//     () =>
//       flattenRoutes(routes, { includeHidden: true }).filter(
//         (r) => !r.roles || r.roles.includes(role)
//       ),
//     [routes, role]
//   );

//   const visibleRoutes = React.useMemo(
//     () =>
//       flattenRoutes(routes, { includeHidden: false }).filter(
//         (r) => !r.roles || r.roles.includes(role)
//       ),
//     [routes, role]
//   );

//   const getBrandText = (pathname) => {
//     const found = (visibleRoutes || []).find((r) => pathname.startsWith(r.path));
//     return found?.name || "หน้าแรก";
//   };

//   const logo = {
//     innerLink: "/index",
//     imgSrc: require("../assets/img/brand/logo.png"),
//     imgAlt: "Logo",
//   };

//   // ✅ รอ setting ก่อน (กันเมนู/route โชว์ผิดชั่วคราว)
//   if (!settingReady) return null; // หรือใส่ spinner ก็ได้

//   return (
//     <>
//       <Sidebar routes={routes} logo={logo} />
//       <MobileSidebarNav routes={routes} logo={logo} />

//       <div className="main-content" ref={mainContent}>
//         <Navbar brandText={getBrandText(location.pathname)} />

//         <Routes>
//           {allRoutes.map((r, i) => (
//             <Route key={i} path={r.path} element={r.component} />
//           ))}
//           <Route path="*" element={<Navigate to="/index" replace />} />
//         </Routes>

//         <Container fluid>
//           <AdminFooter />
//         </Container>
//       </div>
//     </>
//   );
// };

// export default User;

import React from "react";
import { useLocation, Routes, Route, Navigate } from "react-router-dom";
import { Container } from "reactstrap";
import { useAuth } from "../auth/AuthContext";

import Navbar from "components/Navbars/Navbar";
import AdminFooter from "components/Footers/AdminFooter";
import Sidebar from "components/Sidebar/Sidebar";
import MobileSidebarNav from "components/Sidebar/MobileSidebarNav";
import { useRoutes } from "routes";

const flattenRoutes = (rs, { includeHidden = false } = {}) =>
  (Array.isArray(rs) ? rs : [])
    .flatMap((r) =>
      r?.children
        ? r.children.filter((c) => includeHidden || !c.hidden)
        : includeHidden || !r?.hidden
          ? [r]
          : [],
    )
    .filter((r) => r?.path);

const useCurrentRole = () => {
  const { user } = useAuth();
  return (user?.role || localStorage.getItem("role") || "user").toLowerCase();
};

const User = () => {
  const routes = useRoutes();
  const mainContent = React.useRef(null);
  const location = useLocation();
  const role = useCurrentRole();

  const INDEX_PATHS = ["/index", "/", "/submenu-product-service"];
  const isIndexPage = INDEX_PATHS.includes(location.pathname);

  React.useEffect(() => {
    if (isIndexPage) document.body.classList.add("no-sidebar");
    else document.body.classList.remove("no-sidebar");
    return () => document.body.classList.remove("no-sidebar");
  }, [isIndexPage]);

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    if (mainContent.current) mainContent.current.scrollTop = 0;
  }, [location]);

  const allRoutes = React.useMemo(
    () =>
      flattenRoutes(routes, { includeHidden: true }).filter(
        (r) => !r.roles || r.roles.includes(role),
      ),
    [routes, role],
  );

  const visibleRoutes = React.useMemo(
    () =>
      flattenRoutes(routes, { includeHidden: false }).filter(
        (r) => !r.roles || r.roles.includes(role),
      ),
    [routes, role],
  );

  const getBrandText = (pathname) => {
    const found = (visibleRoutes || []).find((r) =>
      pathname.startsWith(r.path),
    );
    return found?.name || "หน้าแรก";
  };

  const logo = {
    innerLink: "/index",
    imgSrc: require("../assets/img/brand/logo.png"),
    imgAlt: "Logo",
  };

  return (
    <>
      {/* ✅ desktop sidebar: ซ่อนบนหน้า index ได้ตามเดิม */}
      {!isIndexPage && <Sidebar routes={routes} logo={logo} />}

      {/* ✅ mobile nav: ให้แสดงเสมอ (มันจะ return null เองถ้าไม่ใช่จอเล็ก) */}
      <MobileSidebarNav routes={routes} logo={logo} />

      <div
        className={`main-content ${isIndexPage ? "main-content--index" : ""}`}
        ref={mainContent}
      >
        {/* ถ้าคุณต้องการ Navbar หายเฉพาะ index ค่อยใส่เงื่อนไขเพิ่มเอง */}
        <Navbar brandText={getBrandText(location.pathname)} />

        <Routes>
          {allRoutes.map((r, i) => (
            <Route key={i} path={r.path} element={r.component} />
          ))}
          <Route path="*" element={<Navigate to="/index" replace />} />
        </Routes>

        {!isIndexPage && (
          <Container fluid>
            <AdminFooter />
          </Container>
        )}
      </div>
    </>
  );
};

export default User;
